import axios from 'axios';
import {BASE_API_URL} from "./config";

const zoomApi = axios.create({
    baseURL: BASE_API_URL + '/appointments'
});

export const postTelehealthAppointment = (appointmentId) => {
    return zoomApi.get(`/${appointmentId}/zoom-meeting/join-url`);
};